// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /squares/results-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeSquaresResultsGetBody,
  typeSquaresResultsGetOutput200,
} from "../../sdk/squares/postSquaresResultsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildSquaresResultsGetQueryKey(
  payload: typeSquaresResultsGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  if (typeof payload.ownerKind !== "undefined") {
    queryKeySegments.push(`ownerKind:${JSON.stringify(payload.ownerKind)}`);
  }
  if (typeof payload.ownerId !== "undefined") {
    queryKeySegments.push(`ownerId:${JSON.stringify(payload.ownerId)}`);
  }
  if (typeof payload.eventId !== "undefined") {
    queryKeySegments.push(`eventId:${JSON.stringify(payload.eventId)}`);
  }
  if (typeof payload.labelKey !== "undefined") {
    queryKeySegments.push(`labelKey:${JSON.stringify(payload.labelKey)}`);
  }
  return [
    "post:squares:squaresResultsGet",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeSquaresResultsGetOutput200,
    unknown,
    typeSquaresResultsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useSquaresResultsGet(
  payload: typeSquaresResultsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildSquaresResultsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postSquaresResultsGet(payload),
    ...resolvedOptions,
  });
}
